import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SelectQuestionComponent } from "./select-question.component";

@NgModule({
  declarations: [SelectQuestionComponent],
  imports: [CommonModule],
  exports: [SelectQuestionComponent]
})
export class SelectQuestionModule {}
